import { Block, Fragment, Text } from '@gitbook/slate';

import { BLOCK_PARAGRAPH } from '../types';

/**
 * Creates an empty fragment.
 */
export function createTextFragment(params: { fragment?: string; text?: string } = {}) {
    return Fragment.create({
        fragment: params.fragment,
        nodes: [
            Block.create({
                type: BLOCK_PARAGRAPH,
                nodes: [Text.create(params.text || '')],
            }),
        ],
    });
}
